// Guide Rating Updater Utility
// This utility automatically updates guide ratings based on their tour performance

import { guideService } from '../services/guideService';

class GuideRatingUpdater {
  private static instance: GuideRatingUpdater;
  private updateInterval: NodeJS.Timeout | null = null;
  private readonly UPDATE_INTERVAL = 5 * 60 * 1000; // 5 minutes

  private constructor() { }

  static getInstance(): GuideRatingUpdater {
    if (!GuideRatingUpdater.instance) {
      GuideRatingUpdater.instance = new GuideRatingUpdater();
    }
    return GuideRatingUpdater.instance;
  }

  // Start automatic rating updates
  startAutoUpdate(): void {
    if (this.updateInterval) {
      return; // Already running
    }

    // Update immediately only if token is present AND user is an admin
    const token = localStorage.getItem('authToken');
    const isAdmin = localStorage.getItem('adminAuth');
    if (token && isAdmin) {
      this.updateAllRatings();
    }


    // Set up interval for periodic updates
    this.updateInterval = setInterval(() => {
      const currentToken = localStorage.getItem('authToken');
      const isAdmin = localStorage.getItem('adminAuth');
      if (currentToken && isAdmin) {
        this.updateAllRatings();
      }
    }, this.UPDATE_INTERVAL);
  }

  // Stop automatic rating updates
  stopAutoUpdate(): void {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
      this.updateInterval = null;
    }
  }

  // Update all guide ratings
  private async updateAllRatings(): Promise<void> {
    try {
      await guideService.updateAllGuideRatings();
    } catch (error: any) {
      // Auto-stop if unauthorized (likely stale session)
      if (error.message?.includes('Insufficient permissions') || error.message?.includes('403')) {
        localStorage.removeItem('adminAuth');
      }
    }
  }

  // Manual update trigger
  async updateRatings(): Promise<void> {
    await this.updateAllRatings();
  }

  // Check if auto-update is running
  isRunning(): boolean {
    return this.updateInterval !== null;
  }
}

export const guideRatingUpdater = GuideRatingUpdater.getInstance();
